import React from "react";
import ReactDOM from "react-dom";
import cloneDeep from "lodash/cloneDeep";

//import './index.css';
import "bootstrap/dist/css/bootstrap.min.css";

import Game from "./components/Game";

import * as CharacterData from "./data/CharacterData";
import * as LocationData from "./data/LocationData";
import * as LootTableData from "./data/LootTableData";
import * as ItemData from "./data/ItemData";


function initHero (char, items) {
  let hero = char;
  for (let i in items) {
    hero.addToInventory(cloneDeep(items[i]))
  }
  return hero;
}

ReactDOM.render(
  <Game
    hero={initHero(CharacterData.defaultHero, [
      ItemData.items.find((e) => e.id === "bronzeSword"),
      //ItemData.items.find((e) => e.id === "bronzeDagger"),
      //ItemData.items.find((e) => e.id === "bronzeGreatsword"),
      //ItemData.items.find((e) => e.id === "steelSword"),
      //ItemData.items.find((e) => e.id === "bronzeHelmet"),
      //ItemData.items.find((e) => e.id === "bronzeGauntlets"),
      //ItemData.items.find((e) => e.id === "bronzeChestplate"),
      //ItemData.items.find((e) => e.id === "bronzeGreeves"),
    ])}
    items={ItemData.items}
    enemies={CharacterData.enemies}
    locations={LocationData.locations}
    lootTables={LootTableData.lootTables}
  />,
  document.getElementById("root")
);
